<script setup lang="ts">import { computed as _computed } from 'vue';


import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {StyleVariantType} from '../../ui/enum/StyleVariantType'
import {ColorVariantType} from '../../ui/enum/ColorVariantType'
import {IconBehavior} from '../../ui/enum/IconBehavior'
import {SizeVariantType} from '@toolify/client/src/modules/ui/enum/SizeVariantType'
import ButtonComponent from '@toolify/client/src/modules/ui/components/ButtonComponent.vue'
import {CypressUniqueNameType} from '@toolify/client/cypress/types/CypressUniqueNameType'

interface Props {
  iconNameType: IconNameType
  iconBehavior?: IconBehavior
  styleVariant?: StyleVariantType
  colorVariant?: ColorVariantType
  reverse?: boolean
  fullWidth?: boolean
}
interface Emits {
  (e: 'iconClick'): void
}
const props = withDefaults(defineProps<Props>(), {
  reverse: false,
  fullWidth: false,
  styleVariant: StyleVariantType.ClearClear,
  colorVariant: ColorVariantType.Dark,
  iconBehavior: IconBehavior.None,
})
const emit = defineEmits<Emits>()
const iconButtonSize = SizeVariantType.Medium

const additionalStyles = _computed(() => {
  if(props.fullWidth) {
    return {
      width: '100%',
    }
  }
})
</script>

<template>
  <div class="input-with-icon" :class="{'reverse': props.reverse, 'has-icon': !!props.iconNameType}" :style="additionalStyles">
    <slot/>
    <ButtonComponent
      v-if="props.iconNameType"
      @click="$emit('iconClick')"
      :iconNameType="props.iconNameType"
      :style="props.styleVariant"
      :color="props.colorVariant"
      :iconBehavior="props.iconBehavior"
      :size="iconButtonSize"
      class="icon"
      :data-cy="CypressUniqueNameType.InputIcon"
    />
    <!-- <i @click.self="$emit('iconClick')" :class="[{'change-style-on-hover': changeStyleOnHover}, props.iconClass]"/> -->
  </div>
</template>

<style scoped lang="scss">
  @use '../../../styles/variables' as variables;

  .icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-right: var(--input-with-icon-icon-margin);
    height: 100%;
    aspect-ratio: 1/1;

    .input-with-icon.reverse & {
      left: 0;
      right: auto;
      margin-right: 0;
      margin-left: var(--input-with-icon-icon-margin);
    }
  }

  .input-with-icon {
    --input-with-icon-icon-size: #{map-get(variables.$componentSizes, medium)};
    --input-with-icon-icon-margin: 6px;
    --input-with-icon-gutter: calc(var(--input-with-icon-icon-size) + var(--input-with-icon-icon-margin));

    position: relative;
    &:hover {
      .change-style-on-hover {
        color: var(--input-search-icon-hover-color);
      }
    }

    &.has-icon:not(.reverse) :deep(input) {
      padding-right: var(--input-with-icon-gutter);
    }

    &.has-icon.reverse :deep(input) {
      padding-left: var(--input-with-icon-gutter);
    }

    & :slotted(.input) {
      width: 100%;
    }
  }
</style>
